



















import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import _ from "lodash";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class SupportCard extends Vue {
  portalCustomizationStore = usePortalCustomizationStore();

  @Prop({ required: false, default: false })
  isLogin: boolean;

  get title () {
    return this.isLogin
        ? "Need Help Logging In?"
        : "Need Help?";
  }
}
